(function() {
  var instances = window.trustBarSliders = window.trustBarSliders || {};
  var mobileQuery = window.matchMedia('(max-width: 989px)');

  function getSectionId(section) {
    return section && section.getAttribute('data-section-id');
  }

  // NEU: liest die Theme-Editor-Einstellungen aus den data-Attributen
  function getAutoPlay(section) {
    var speed;

    if (section.getAttribute('data-trust-bar-autoplay') !== 'true') {
      return false;
    }

    speed = parseInt(section.getAttribute('data-trust-bar-autoplay-speed'), 10);

    if (isNaN(speed) || speed < 500) {
      speed = 2000;
    }

    return speed;
  }

  function destroy(section) {
    var sectionId = getSectionId(section);

    if (!sectionId || !instances[sectionId]) {
      return;
    }

    if (typeof instances[sectionId].destroy === 'function') {
      instances[sectionId].destroy();
    }

    delete instances[sectionId];
  }

  function initSection(section, attempts) {
    var sectionId = getSectionId(section);
    var track;

    attempts = attempts || 0;

    if (!sectionId || instances[sectionId] || !mobileQuery.matches) {
      return;
    }

    if (!window.Flickity) {
      if (attempts < 20) {
        window.setTimeout(function() {
          initSection(section, attempts + 1);
        }, 100);
      }

      return;
    }

    track = section.querySelector('[data-trust-bar-slider]');

    if (!track || track.children.length < 2) {
      return;
    }

    instances[sectionId] = new Flickity(track, {
      adaptiveHeight: false,
      autoPlay: getAutoPlay(section), // GEÄNDERT: war fest "false"
      cellAlign: 'center',
      contain: false,
      draggable: true,
      fade: false,
      pageDots: false,
      pauseAutoPlayOnHover: false, // NEU
      prevNextButtons: false,
      setGallerySize: true,
      watchCSS: false,
      wrapAround: true
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-trust-bar-section]').forEach(function(section) {
      if (mobileQuery.matches) {
        initSection(section);
      } else {
        destroy(section);
      }
    });
  }

  function handleResize() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', handleResize);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(handleResize);
  }

  document.addEventListener('shopify:section:load', function(event) {
    // NEU: alte Slider-Instanz verwerfen, damit Änderungen im Theme-Editor sofort greifen
    (event.target || document).querySelectorAll('[data-trust-bar-section]').forEach(destroy);
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var section = event.target && event.target.querySelector('[data-trust-bar-section]');

    if (section) {
      destroy(section);
    }
  });
})();